"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomEinsteinAPI = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _einstein = require("../einstein");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
class CustomEinsteinAPI extends _einstein.EinsteinAPI {
  /**
   * Get a set of recommendations
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  getRecommendations(recommenderName, args) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      // @ts-ignore
      const endpoint = `/personalization/recs/${_this.config.siteId}/${recommenderName}`;
      const method = 'POST';
      const body = _objectSpread({}, args);

      // Fetch the recommendations
      const reco = yield _this.einsteinFetch(endpoint, method, body);
      reco.recommenderName = recommenderName;

      // Validate einstein recommended products
      const validatedProducts = yield _this.validateProductsViaSearch(reco);
      return validatedProducts;
    })();
  }
  validateProductsViaSearch(reco) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var _reco$recs;
      const ids = (_reco$recs = reco.recs) === null || _reco$recs === void 0 ? void 0 : _reco$recs.map(rec => rec.id);
      if ((ids === null || ids === void 0 ? void 0 : ids.length) > 0) {
        const searchParams = {
          refine: [`ID=${ids.join('|')}`]
        };
        // Fetch the product details for the recommendations
        // @ts-ignore
        const search = yield _this2.commerceAPI.shopperSearch.productSearch({
          parameters: searchParams
        });
        const singleProductPerMaster = {};
        const filteredSearchHits = search === null || search === void 0 ? void 0 : search.hits.filter(item => {
          // @ts-ignore
          if (item.c_masterId && singleProductPerMaster[item.c_masterId]) {
            return false;
          }

          // @ts-ignore
          singleProductPerMaster[item.c_masterId || 'default'] = true;
          return true;
        }, {});
        const recs = yield Promise.all(filteredSearchHits.map(({
          productId
        }) => _this2.fetchRecProductDetails(productId)));

        // Merge the product detail into the recommendations response
        return _objectSpread(_objectSpread({}, reco), {}, {
          recs
        });
      }
      return reco;
    })();
  }
  fetchRecProductDetails(productId) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      // Fetch the product details for the recommendations
      // @ts-ignore
      const product = yield _this3.commerceAPI.shopperProducts.getProduct({
        parameters: {
          id: productId
        }
      });
      return product;
    })();
  }
}
exports.CustomEinsteinAPI = CustomEinsteinAPI;